import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, type RouterHistory } from '@tanstack/react-router';
import { useState } from 'react';
import { ApiError, type AdminApi } from './api/client.ts';
import { createAppRouter } from './routes/router.tsx';

export function App({ api, history }: { api: AdminApi; history?: RouterHistory }) {
  const [{ queryClient, router }] = useState(() => {
    const ref: { router?: ReturnType<typeof createAppRouter> } = {};
    const client = new QueryClient({
      defaultOptions: { queries: { retry: false } },
      queryCache: new QueryCache({
        onError: (error) => {
          // An expired or missing session sends the user to sign in and back to where they were.
          const appRouter = ref.router;
          if (error instanceof ApiError && error.status === 401 && appRouter) {
            const { pathname, searchStr } = appRouter.state.location;
            if (pathname !== '/login') {
              void appRouter.navigate({ to: '/login', search: { returnTo: `${pathname}${searchStr}` } });
            }
          }
        },
      }),
    });
    ref.router = createAppRouter({ api, queryClient: client }, history);
    return { queryClient: client, router: ref.router };
  });
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
